import { render, staticRenderFns } from "./buybackTransaction.vue?vue&type=template&id=00d35740&scoped=true&"
import script from "./buybackTransaction.vue?vue&type=script&lang=js&"
export * from "./buybackTransaction.vue?vue&type=script&lang=js&"
import style0 from "./buybackTransaction.vue?vue&type=style&index=0&id=00d35740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d35740",
  null
  
)

export default component.exports